export default "__VITE_ASSET__dLjzvT_f__"